var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inventory-record"},[_c('x-table',{attrs:{"columns":_vm.table.columns,"data":_vm.table.data,"loading":_vm.table.loading,"config":_vm.config},on:{"search":_vm.search,"loadExpend":_vm.loadExpend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }